module.exports = __webpack_public_path__ + "5974612377aac7e127303debd875a346.svg";